import angular from 'angular';
import { flatten } from 'lodash';

module.exports = angular.module('market.routes.vendor_help.index', [
  require('market/models/vendor-question'),
  require('./prospective'),
  require('./current'),
  require('./media'),
  require('./quality'),
])
.config(function($stateProvider) {
  $stateProvider.state('vendor_help', {
    parent: 'root',
    url: '/vendor-help',
    template: require('./index.jade')(),
    data: {
      meta: {
        titleSuffix: " | Vendor Help Center",
      }
    },
    controller: class {
      constructor(
        $location,
        $state,
        $scope,
        $anchorScroll,
        ALL_MARKETS,
        VendorQuestion,
      ) {
        this.showVendorHelpModal = false;
        this.VendorQuestion = VendorQuestion;
        this.markets = flatten([ALL_MARKETS, 'other']);
        if ($location.path() === '/vendor-help') {
          $state.go('vendor_help.prospective');
        }
        // for od-collapsible-question, scrolls after components have computed their hashes
        $scope.$on('$viewContentLoaded', () => $anchorScroll());
      }

      openVendorHelpModal() {
        this.question = new this.VendorQuestion();
        this.showVendorHelpModal = true;
      }

      sendVendorQuestion() {
        this.question.$save().then(() => {
          this.showVendorHelpModal = false;
          this.question = new this.VendorQuestion();
        });
      }
    },
    controllerAs: 'vendor_help'
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/vendor-help/index.js
 **/